// type UntypedIterator = (value: any, key?: any, object?: any) => boolean;
type TypedIterator<T extends object, U extends keyof T> = (
  value: T[U],
  key: U,
  object: T
) => boolean;

// export function findKey<T extends object, U extends keyof T>(object: T, value: T[U]);
// export function findKey<T extends object, U extends keyof T>(
//   object: T,
//   iteratorFunction: TypedIterator<T, U> | UntypedIterator
// );
export function findKey<T extends object, U extends keyof T>(
  object: T,
  valueOrIterator: T[U] | ((value: any, key?: any, object?: any) => boolean)
): U | undefined {
  return Object.keys(object).find((key) => {
    if (typeof valueOrIterator === 'function')
      return (valueOrIterator as TypedIterator<T, U>)(object[key as U], key as U, object);
    return object[key as U] === valueOrIterator;
  }) as U | undefined;
}
